<template>
  <div class="ctep-breadcrumb-box">
    <span>{{ activeName }}</span>
    <span
      >您的位置：<span @click="handleClick(0)">首页</span><span @click="handleClick(1)">&nbsp;/&nbsp;{{ firstMenu.name }}</span
      ><span>&nbsp;/&nbsp;{{ activeName }}</span>
    </span>
  </div>
</template>

<script>
import { getMenuById } from "@/config/menus";

export default {
  name: "CtepBreadcrumb",
  data() {
    return {
      firstMenu: {},
      secondMenu: [],
      currentMenu : null,
      activeName: "",
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(v) {
        let menuId = v.params?.menuId || v.query?.linkMenuId || sessionStorage.getItem("asideActiveId")|| ""
        let firstId = menuId.substring(0, 3);
        // 新闻搜索
        if(menuId === "local001001" || v.name === "search") {
          firstId = "local001";
          menuId = "local001001";
        }
        if (menuId) {
          if (menuId === this.firstMenu.id) {
            this.activeName = this.firstMenu.children[0].name;
            return;
          }
          if (firstId !== this.firstMenu.id) {
            this.firstMenu = getMenuById(firstId) || [];
            this.secondMenu = this.firstMenu?.children || [];
          }
          this.currentMenu = this.secondMenu.find((menu) => menu.id === menuId)
          this.activeName = this.currentMenu?.name || this.firstMenu.children[0].name;
        }
      },
    },
  },
  methods: {
    handleClick(levl) {
      if(levl === 1) {
        if(this.firstMenu.id === "local001") {
          return
        } else {
          this.$router.push(`/index/lists/${this.firstMenu.id}`)
        }
      } else {
        this.$router.push(`/`)
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ctep-breadcrumb-box {
  height: 30px;
  line-height: 26px;
  line-height: 30px;
  border-bottom: 1px solid #ddd;
  display: flex;
  > span:first-child {
    flex: 2;
    font-size: 18px;
  }
  > span:last-child {
    flex: 3;
    font-size: 12px;
    text-align: right;
    span {
      cursor: pointer;
      &:hover, &:last-child {
        color: #fdc202
      }
      &:last-child {
        cursor: initial;
      }
    }
  }
}
</style>
